import React, { useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';

import { ITileGridFields } from '../../../types/contentful';

import { breakpoints } from '../../styles/media-queries';

import { QuickStartGuideBox } from '../QuickStartGuideBox';
import { ScrollReveal } from '../ScrollReveal';

export function TileGrid({ boxes }: ITileGridFields) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(
      typeof window !== `undefined` && window.innerWidth < breakpoints.tablet
    );
  }, []);

  return (
    <ScrollReveal>
      <div
        className="block-container mb-12 mt-0 tablet:mb-16 tablet:mt-16"
        data-blockid="tile-grid"
        data-testid="tile-grid"
      >
        <div className="-mx-2 box-border flex w-full flex-wrap items-center justify-center tablet:-mx-3 desktop:-mx-4">
          <div className="box-column w-full px-2 pt-0 tablet:px-3 desktop:w-10/12 desktop:px-4 desktop:pt-1">
            {isMobile ? (
              (boxes || []).map(({ sys, fields }) => (
                <QuickStartGuideBox {...fields} key={sys.id} />
              ))
            ) : (
              <div className="masonry-wrapper">
                <Masonry
                  breakpointCols={2}
                  className="masonry-grid"
                  columnClassName="masonry-grid-column"
                >
                  {(boxes || []).map(({ sys, fields }) => (
                    <QuickStartGuideBox {...fields} key={sys?.id} />
                  ))}
                </Masonry>
              </div>
            )}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
